import React from 'react';
import { ImportSummaryTotals } from '../../../types/bulkAssignment';
import styles from './ImportSummary.module.css';

interface ImportSummaryProps {
  totals: ImportSummaryTotals;
  minEvaluatorsPerApplication: number;
}

const ImportSummary: React.FC<ImportSummaryProps> = ({
  totals,
  minEvaluatorsPerApplication,
}) => {
  const tiles = [
    {
      label: 'Postulaciones en el archivo',
      value: totals.applicationsInFile,
      note: null as string | null,
    },
    {
      label: 'Asignaciones a crear',
      value: totals.toCreate,
      note:
        totals.discarded > 0 ? `${totals.discarded} descartadas por ti` : null,
    },
    {
      label: `Quedan con ${minEvaluatorsPerApplication} o más evaluadores`,
      value: totals.withFullCoverage,
      note: null,
    },
    {
      label: 'Requieren gestión manual',
      value: totals.totalIssues,
      note: totals.blocked > 0 ? `${totals.blocked} matches no se importan` : null,
      warning: totals.totalIssues > 0,
    },
    {
      label: 'Evaluadores involucrados',
      value: totals.evaluatorsInvolved,
      note: null,
    },
  ];

  return (
    <ul className={styles.tiles}>
      {tiles.map((tile) => (
        <li
          key={tile.label}
          className={`${styles.tile} ${tile.warning ? styles.warning : ''}`}
        >
          <span className={`uc-kpi-xl ${styles.value}`}>{tile.value}</span>
          <span className={`uc-p-body-small ${styles.label}`}>{tile.label}</span>
          {tile.note && (
            <span className={`uc-p-body-small ${styles.note}`}>{tile.note}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default ImportSummary;
